import { render } from "./AddDevice.vue?vue&type=template&id=38f135ba&scoped=true"
import script from "./AddDevice.vue?vue&type=script&lang=js"
export * from "./AddDevice.vue?vue&type=script&lang=js"

import "./AddDevice.vue?vue&type=style&index=0&id=38f135ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f135ba"]])

export default __exports__